import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { PageHeader } from "../../components/PageHeader";
import { Input } from "../../components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

const Respaldo = ({ cid }) => {
  const [tipo, setTipo] = useState("rut");
  const up = async (file) => {
    const fd = new FormData();
    fd.append("tipo", tipo);
    fd.append("archivo", file);
    try {
      await api.post(`/admin/companies/${cid}/respaldos`, fd);
      toast.success("Respaldo cargado");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="flex items-center gap-1">
      <select className="h-8 border rounded text-xs" value={tipo} onChange={(e) => setTipo(e.target.value)} data-testid={`respaldo-tipo-${cid}`}>
        <option value="rut">RUT</option><option value="inicio_actividades">Inicio de actividades</option><option value="otro">Otro</option>
      </select>
      <Input type="file" className="h-8 w-44 text-xs" accept="application/pdf,image/jpeg,image/png" onChange={(e) => e.target.files[0] && up(e.target.files[0])} data-testid={`respaldo-file-${cid}`} />
    </div>
  );
};

export default function Uso() {
  const [items, setItems] = useState([]);
  const [didit, setDidit] = useState(null);
  useEffect(() => {
    api.get("/admin/uso").then((r) => { setItems(r.data.items); setDidit(r.data.didit); });
  }, []);
  return (
    <div className="space-y-6">
      <PageHeader overline="Superadmin" title="Uso por empresa" />
      {didit && <p className={`text-sm ${didit.alerta ? "text-rose-700 font-semibold" : "text-slate-600"}`} data-testid="usage-didit">
        Sesiones de Didit en {didit.mes}: {didit.total} de {didit.incluidas_plan_gratis} del plan gratis{didit.alerta ? " — ¡pasó de 400!" : ""}{didit.configurado ? "" : " (Didit no configurado: se usa el motor propio)"}
      </p>}
      <p className="text-sm text-slate-500">Sin datos personales de clientes finales.</p>
      <Table data-testid="usage-table">
        <TableHeader><TableRow>{["Empresa", "Estado", "Verificaciones del mes", "Sesiones Didit del mes", "Clientes activos", "Casos abiertos", "Respaldo RUT / inicio de actividades"].map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
        <TableBody>
          {items.map((c) => (
            <TableRow key={c.id}>
              <TableCell>{c.nombre_fantasia}</TableCell><TableCell>{c.estado}</TableCell><TableCell>{c.verificaciones_mes}</TableCell><TableCell>{c.didit_sesiones_mes}</TableCell>
              <TableCell>{c.clientes_activos}</TableCell><TableCell>{c.casos_abiertos}</TableCell><TableCell><Respaldo cid={c.id} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
